import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useAuthState } from "react-firebase-hooks/auth";
import { db, auth } from "../../../../firebase";
import {
  collection,
  addDoc,
  doc,
  query,
  where,
  getDocs,
  updateDoc,
  getDoc,
} from "firebase/firestore";

import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Notes from "../../../../components/common/Notes";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import AdditionalTenants from "./components/AdditionalTenants";
import FinishMoveIn from "./components/FinishMoveIn";
import GenerateLease from "./components/GenerateLease";
import LeaseDetails from "./components/LeaseDetails";
import Profile from "./components/Profile";
import SelectUnit from "./components/SelectUnit";

import { Card, Col, Form, Row, Steps } from "antd";

import { SelectMoveInTenantInfo } from "../../../../store/moveInTenantSlice";

import "./MoveInTenant.css";

const MoveInTenantRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Save For Later", "1", "", "", ""),
    RightBarMethod("View Upcoming Move Ins", "2", "", "", ""),
  ]),
];

function MoveInTenant() {
  const [current, setCurrent] = useState(0);
  const moveInTenantInfo = useSelector(SelectMoveInTenantInfo);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");

  const today = new Date();
  const day = today.toLocaleString("en-US", { weekday: "long" });
  const month = today.toLocaleString("en-US", { month: "long" });
  const dayNumber = today.getDate();
  const year = today.getFullYear();
  let hours = today.getHours();
  const minutes = today.getMinutes();
  const seconds = today.getSeconds();
  const ampm = hours >= 12 ? "pm" : "am";
  hours %= 12;
  hours = hours ? hours : 12;

  const stepTowClick = () => {
    if (
      moveInTenantInfo.profileInfo.firstName !== "" &&
      moveInTenantInfo.profileInfo.lastName !== ""
    ) {
      setCurrent(1);
    } else {
      toast.error("Important fields can't be blanked");
    }
  };

  const stepFourClick = () => {
    if (Object.keys(moveInTenantInfo.propertyUnit).length !== 0) {
      setCurrent(3);
    } else {
      toast.error("Please select one property unit");
    }
  };

  const steps = [
    {
      title: (
        <span className="step" onClick={() => setCurrent(0)}>
          Profile
        </span>
      ),
      content: (
        <Profile current={current} stepsLength={5} setCurrent={setCurrent} />
      ),
    },
    {
      title: (
        <span className="step" onClick={() => stepTowClick()}>
          Additional Tenants
        </span>
      ),
      content: (
        <AdditionalTenants
          current={current}
          stepsLength={5}
          setCurrent={setCurrent}
        />
      ),
    },
    {
      title: (
        <span className="step" onClick={() => setCurrent(2)}>
          Select Unit
        </span>
      ),
      content: (
        <SelectUnit current={current} stepsLength={5} setCurrent={setCurrent} />
      ),
    },
    {
      title: (
        <span className="step" onClick={() => stepFourClick()}>
          Lease Details
        </span>
      ),
      content: (
        <LeaseDetails
          current={current}
          stepsLength={5}
          setCurrent={setCurrent}
        />
      ),
    },
    {
      title: (
        <span className="step" onClick={() => setCurrent(4)}>
          Generate Lease
        </span>
      ),
      content: (
        <GenerateLease
          current={current}
          stepsLength={5}
          setCurrent={setCurrent}
        />
      ),
    },
    {
      title: (
        <span className="step" onClick={() => setCurrent(5)}>
          Finish Move In
        </span>
      ),
      content: (
        <FinishMoveIn
          current={current}
          stepsLength={5}
          setCurrent={setCurrent}
        />
      ),
    },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const [notes, setNotes] = useState([]);

  console.log("....profileInfo", moveInTenantInfo.profileInfo);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const [tenant, setTenant] = useState({});

  useEffect(() => {
    if (companyName) {
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(db, "companies", companyName, "tenants");
          const snapshot = await getDocs(tenantRef);

          const fetchData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          const newObject = fetchData.find((item) => {
            return item.id === moveInTenantInfo?.tenantId;
          });
          console.log("set tenants useEffect in TenantDetails.js");
          setTenant(newObject);
        } catch (err) {
          console.log(err);
          toast.error("Error while fetching data", err);
        }
      };
      console.log("Tenants useEffect in TenantDetails.js");
      fetchTenants();
    }
  }, [companyName]);

  return (
    <>
      <div className="move-in-tenant">
        <PageHeading heading="Move In Tenant" />
        <div className="move-in-tenant-container">
          <Row>
            <Col span={4}>
              <Steps
                current={current}
                items={items}
                direction="vertical"
                size="small"
              />
            </Col>
            <Col span={20} className="steps-container">
              <div>{steps[current].content}</div>
            </Col>
          </Row>
          <Row gutter={[16, 0]}>
            {moveInTenantInfo.profileInfo.firstName &&
            moveInTenantInfo.profileInfo.lastName ? (
              <Col span={12}>
                <Card title="Tenant Information">
                  <Form
                    colon={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 6 }}
                  >
                    <Form.Item label="Name">
                      <p>
                        {moveInTenantInfo.profileInfo.firstName}{" "}
                        {moveInTenantInfo.profileInfo.lastName}
                      </p>
                    </Form.Item>
                    <Form.Item label="Phone Numbers">
                      <p>
                        {moveInTenantInfo?.profileInfo?.phoneNumbers
                          ? moveInTenantInfo?.profileInfo?.phoneNumbers[0]
                              ?.phoneNumber
                          : "--"}
                      </p>
                    </Form.Item>
                    <Form.Item label="Email">
                      <p>
                        {moveInTenantInfo?.profileInfo?.emails
                          ? moveInTenantInfo?.profileInfo?.emails[0]?.email
                          : "--"}
                      </p>
                    </Form.Item>
                  </Form>
                </Card>
              </Col>
            ) : null}
            {moveInTenantInfo.propertyUnit?.value !== undefined ? (
              <Col span={12}>
                <Card title="Tenant Information">
                  <Form
                    colon={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Form.Item label="Address">
                      <p>{moveInTenantInfo.propertyUnit?.value}</p>
                    </Form.Item>
                    <Form.Item label="Market Rent">
                      <p>{moveInTenantInfo.propertyUnit?.marketRent}</p>
                    </Form.Item>
                    <Form.Item label="Status">
                      <p>{moveInTenantInfo.propertyUnit?.status}</p>
                    </Form.Item>
                    <Form.Item label="Property">
                      <p>{moveInTenantInfo.propertyUnit?.value}</p>
                    </Form.Item>
                  </Form>
                </Card>
              </Col>
            ) : null}
          </Row>
          {/* {moveInTenantInfo.profileInfo.firstName !== "" &&
          moveInTenantInfo.profileInfo.lastName !== "" ? (
            <Row>
              <Col span={24}>
                <Card title="History">
                  <p>
                    Added {moveInTenantInfo.firstName}{" "}
                    {moveInTenantInfo.lastName} to this Occupancy, -{" "}
                    <span className="onclick-text">aamir ali</span> on {day},{" "}
                    {month} {dayNumber}, {year} at {hours}:
                    {minutes.toString().padStart(2, "0")}:{seconds} {ampm}
                  </p>
                  {moveInTenantInfo.additionalTenants.map((item, index) => {
                    return (
                      <p key={index}>
                        Added {item.firstName} {item.lastName} to this
                        Occupancy, - <span className="onclick-text">aamir ali</span>{" "}
                        on {day}, {month} {dayNumber}, {year} at {hours}:
                        {minutes.toString().padStart(2, "0")}:{seconds} {ampm}
                      </p>
                    );
                  })}
                </Card>
              </Col>
            </Row>
          ) : null} */}

          <Row gutter={[0, 24]}>
            <Col span={24}>
              {moveInTenantInfo.tenantId ? (
                <>
                  <Col span={24}>
                    {companyName ? (
                      <Notes
                        notesForCollection="tenants"
                        notesForCollectionId={moveInTenantInfo.tenantId}
                        companyName={companyName}
                        notes={notes}
                        setNotes={setNotes}
                      />
                    ) : null}
                  </Col>
                  <br/>
                  <Col span={24}>
                    {companyName ? (
                      <AttachmentsUpload
                        id={moveInTenantInfo.tenantId}
                        data={tenant?.attachments}
                        companyName={companyName}
                        collection="tenants"
                      />
                    ) : null}
                  </Col>
                </>
              ) : null}
            </Col>
          </Row>
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={MoveInTenantRightBar} />
      </div>
    </>
  );
}

export default MoveInTenant;
